/**
 * Source: https://github.com/microsoft/monaco-editor/tree/main/src/basic-languages
 */
export const defaultLanguages: Record<string, string> = {
  abap: 'ABAP',
  apex: 'Apex',
  azcli: 'Azure CLI',
  bat: 'Batch',
  bicep: 'Bicep',
  cameligo: 'CameLIGO',
  clojure: 'Clojure',
  coffee: 'CoffeeScript',
  cpp: 'C++',
  csharp: 'C#',
  csp: 'CSP',
  css: 'CSS',
  cypher: 'Cypher',
  dart: 'Dart',
  dockerfile: 'Dockerfile',
  ecl: 'ECL',
  elixir: 'Elixir',
  flow9: 'Flow9',
  freemarker2: 'FreeMarker 2',
  fsharp: 'F#',
  go: 'Go',
  graphql: 'GraphQL',
  handlebars: 'Handlebars',
  hcl: 'HCL',
  html: 'HTML',
  ini: 'INI',
  java: 'Java',
  javascript: 'JavaScript',
  julia: 'Julia',
  kotlin: 'Kotlin',
  less: 'Less',
  lexon: 'Lexon',
  liquid: 'Liquid',
  lua: 'Lua',
  m3: 'M3',
  markdown: 'Markdown',
  mdx: 'MDX',
  mips: 'MIPS',
  msdax: 'DAX',
  mysql: 'MySQL',
  'objective-c': 'Objective-C',
  pascal: 'Pascal',
  pascaligo: 'PascaLIGO',
  perl: 'Perl',
  pgsql: 'PostgreSQL',
  php: 'PHP',
  pla: 'PLA',
  plaintext: 'Plain Text',
  postiats: 'Postiats',
  powerquery: 'Power Query',
  powershell: 'PowerShell',
  protobuf: 'Protobuf',
  pug: 'Pug',
  python: 'Python',
  qsharp: 'Q#',
  r: 'R',
  razor: 'Razor',
  redis: 'Redis',
  redshift: 'Amazon Redshift',
  restructuredtext: 'reStructuredText',
  ruby: 'Ruby',
  rust: 'Rust',
  sb: 'Small Basic',
  scala: 'Scala',
  scheme: 'Scheme',
  scss: 'SCSS',
  shell: 'Shell',
  solidity: 'Solidity',
  sophia: 'Sophia',
  sparql: 'SPARQL',
  sql: 'SQL',
  st: 'Structured Text',
  swift: 'Swift',
  systemverilog: 'SystemVerilog',
  tcl: 'Tcl',
  twig: 'Twig',
  typescript: 'TypeScript',
  typespec: 'TypeSpec',
  vb: 'Visual Basic',
  wgsl: 'WGSL',
  xml: 'XML',
  yaml: 'YAML',
}
